import { http } from "helpers/Http";
import logger from "../../../../components/Logger";

const path = 'src/services/api/requests/RegisterGuest/index.ts'

export function postRegisterGuest(place_id: string): Promise<any> {
    const url = `users/new?current_app_id=${place_id}&cardapio_web=true`;
    const data = http.post(url, GuestUser).then((response) => response.data);


    logger.log("************************************************************************************")
    logger.log(`| FILE: ${path} | METHOD: postUpdateUserOrderStatus`)
    logger.log("| url: ", url)
    logger.log("| ORDER place_id: ", place_id)
    logger.log("| promise returned ", data)
    logger.log("************************************************************************************")

    return data;
}

const GuestUser = {
    name: "Visitante",
    guest_user: true,
    phone_number: "",
    email: "",
    password: "220309"
}